import { render, staticRenderFns } from "./BrandToggleFontSizes.vue?vue&type=template&id=c5f3ed44&"
import script from "./BrandToggleFontSizes.vue?vue&type=script&lang=ts&"
export * from "./BrandToggleFontSizes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports